{
  "deselectedItem": "{item}이(가) 선택되지 않았습니다.",
  "select": "선택",
  "selectedAll": "모든 항목이 선택되었습니다.",
  "selectedCount": "{count, plural, =0 {선택된 항목이 없습니다} one {#개 항목이 선택되었습니다} other {#개 항목이 선택되었습니다}}.",
  "selectedItem": "{item}이(가) 선택되었습니다."
}
